import { createStore, applyMiddleware, compose } from "redux";
import { routerMiddleware } from "react-router-redux";
import thunk from "redux-thunk";
import createHistory from "history/createBrowserHistory";

import { rootReducer } from "./rootreducer";
import { loadState, saveState } from "REDUX/localstorage";

export const history = createHistory();

const persistedState = loadState();
const enhancers = [];
const middleware = [thunk, routerMiddleware(history)];

if (process.env.NODE_ENV === "development") {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === "function") {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
);

const store = createStore(rootReducer, persistedState, composedEnhancers);

// ========================================================
// Persist data on page refresh
// ========================================================
store.subscribe(() => {
  saveState(store.getState());
});

export default store;



// WEBPACK FOOTER //
// ./src/redux/store.js